export default __webpack_public_path__ + "static/media/jolt-100-7.faed419b.jpg";